import React, { useEffect, useState } from "react";
import { Drawer, Tabs, Tab, Box, Typography, IconButton, Divider, Button } from "@mui/material";
import { IoIosClose } from "react-icons/io";
import { generateSampleExcel } from "../../../controllers/SamplesController";
import { sample_enum_mappings } from "../../../utils/SamplesEnum";
import { formatDateOnly, formatTimeOnly } from "../../../utils/Utils";

const DataDetailsDrawer = ({ open, onClose, sampleData }) => {
    const [sample, setSample] = useState({});
    const [tabIndex, setTabIndex] = useState(0);
    const [excelLink, setExcelLink] = useState(null);
    const [isGenerating, setIsGenerating] = useState(false);

    useEffect(() => {
        if (sampleData) {
            const formatted = { ...sampleData };
            Object.keys(sample_enum_mappings).forEach((key) => {
                console.log("Key:", key, "Sample Value:", sampleData[key]);
                if (sampleData[key]) {

                    formatted[key] = Object.values(sample_enum_mappings[key])[sampleData[key]-1];
                }
            });
            setSample(formatted);
        }
        console.log("Formatted Sample:", sample);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sampleData]);

    const handleChange = (event, newIndex) => {
        setTabIndex(newIndex);
    };

    const handleClose = () => {
        onClose();
        setTabIndex(0);
        setExcelLink(null);
    };

    const formatImage = (image) => {
        return image.replace("dataimage/jpegbase64", "data:image/jpg;base64,");
    }

    const handleGenerateExcel = async () => {
        if (!sample?.id) return;
        try {
            setIsGenerating(true);
            setExcelLink(null);
            const { view_link } = await generateSampleExcel(sample.id);
            setExcelLink(view_link);
        } catch (error) {
            console.error("Erreur lors de la génération du fichier Excel:", error);
        } finally {
            setIsGenerating(false);
        }
    };

    return (
        sample &&
        <Drawer anchor="right" open={open} onClose={handleClose}>
            <Box sx={{ width: "fit-content", p: 2 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box display="flex" flexDirection="column">
                        <Typography variant="h5">Détails du prélèvement </Typography>
                        <Typography variant="subtitle1">{sample.id}</Typography>
                    </Box>
                    <IconButton onClick={onClose}>
                        <IoIosClose />
                    </IconButton>
                </Box>
                <Box sx={{ width: 600, height: "100vh", display: "flex" }}>
                    <Box
                        sx={{ width: 150, borderRight: 1, borderColor: "divider", bgcolor: "background.paper" }}>
                        <Tabs value={tabIndex} onChange={handleChange} variant="standard" orientation="vertical">
                            <Tab label="Informations générales" />
                            <Tab label="Caractérisation du site d'étude" />
                            <Tab label="Contexte environnemental" />
                            <Tab label="Déchets macro" />
                            <Tab label="Télécharger le fichier Excel" />
                        </Tabs>
                    </Box>
                    <Box sx={{ flex: 1, p: 3 }}>
                        {tabIndex === 0 && (
                            <Box>
                                <Typography variant="h6" fontWeight="bold">Informations générales </Typography>
                                {sample.site_location && <Typography>Localisation du site: {sample.site_location}</Typography>}
                                {(sample.sample_date && sample.sample_time) && <Typography>Date et heure: {formatDateOnly(sample.sample_date)} à {formatTimeOnly(sample.sample_time)}</Typography>}
                                {sample.seaboard && <Typography>Nom de la côte: {sample.seaboard}</Typography>}
                                {sample.river_name && <Typography>Nom de la rivière: {sample.river_name}</Typography>}
                                {sample.image && <img width="400rem" src={formatImage(sample.image)} alt="site" />}
                                {/* <Divider />
                                <Typography variant="subtitle1" fontWeight="bold">Informations des participants </Typography>
                                {(sample.etablishment_name && sample.etablishment_commune) && <Typography>Établissement: {sample.etablishment_name} ({sample.etablishment_commune})</Typography>}
                                {sample.class_level && <Typography>Niveau scolaire: {sample.class_level}</Typography>}
                                {sample.number_of_students && <Typography>Nombre d'étudiants: {sample.number_of_students}</Typography>}
                                {sample.academy_number && <Typography>Numéro de l'académie: {sample.academy_number}</Typography>}
                                <Divider />
                                <Typography variant="subtitle1" fontWeight="bold">Informations du site </Typography>
                                {(sample.site_code && sample.site_name) && <Typography>Site Name: {sample.site_name} ({sample.site_code})</Typography>}
                                {sample.department_number && <Typography>Numéro de département: {sample.department_number}</Typography>}
                                {sample.commune_name && <Typography>Nom de la commune: {sample.commune_name}</Typography>} */}
                            </Box>
                        )}
                        {tabIndex === 1 && (
                            <Box>
                                <Typography variant="h6" fontWeight="bold">Caractérisation du site d'étude</Typography>
                                {sample.transect_length && <Typography>Distance transecte: {sample.transect_length} m</Typography>}
                                {sample.back_site_type && <Typography>Type d'environnement: {sample.back_site_type}</Typography>}

                                <Divider />

                                <Typography variant="subtitle1" fontWeight="bold">Coordonnées GPS</Typography>
                                {sample.start_gps_latitude && <Typography>Latitude initiale: {sample.start_gps_latitude}</Typography>}
                                {sample.start_gps_longitude && <Typography>Longitude initiale: {sample.start_gps_longitude}</Typography>}
                                {sample.end_gps_latitude && <Typography>Latitude finale: {sample.end_gps_latitude}</Typography>}
                                {sample.end_gps_longitude && <Typography>Longitude finale: {sample.end_gps_longitude}</Typography>}

                                <Divider />

                                <Typography variant="subtitle1" fontWeight="bold">Autres informations</Typography>
                                {/* {sample.currents_direction && <Typography>Direction des courants: {sample.currents_direction}</Typography>}
                                {sample.winds_direction && <Typography>Direction des vents: {sample.winds_direction}</Typography>}
                                {sample.site_direction && <Typography>Direction du site: {sample.site_direction} m/s</Typography>} */}

                                {sample.main_material && <Typography>Site Material: {sample.main_material}</Typography>}
                                {sample.pollution_influence && <Typography>Niveau de pollution: {sample.pollution_influence}</Typography>}
                                {sample.yearly_usage && <Typography>Utilisation annuelle: {sample.yearly_usage}</Typography>}
                                {sample.summer_usage && <Typography>Utilisation estivale : {sample.summer_usage}</Typography>}
                                {sample.foot_accessibility && <Typography>Accessibilité à pied: {sample.foot_accessibility}</Typography>}
                            </Box>

                        )}
                        {tabIndex === 2 && (
                            <Box>
                                <Typography variant="h6" fontWeight="bold">Contexte environnemental</Typography>
                                {/* {sample.nearest_agglomeration && sample.agglomeration_distance !== undefined && (
                                    <Typography>Agglomération la plus proche: {sample.nearest_agglomeration} ({sample.agglomeration_distance} km)</Typography>
                                )}
                                {sample.agglomeration_type && <Typography>Type d'agglomération: {sample.agglomeration_type}</Typography>}
                                {sample.distance_to_coastline !== undefined && <Typography>Distance de la côte: {sample.distance_to_coastline} km</Typography>}

                                <Divider /> */}

                                {/* <Typography variant="subtitle1" fontWeight="bold">Informations sur le port à proximité</Typography>
                                {sample.nearest_port_name && sample.nearest_port_type && (
                                    <Typography>Nom du port: {sample.nearest_port_name} ({sample.nearest_port_type})</Typography>
                                )}
                                {sample.nearest_port_distance !== undefined && <Typography>Distance du port: {sample.nearest_port_distance} km</Typography>}
                                {sample.nearest_port_size && <Typography>Grandeur du port: {sample.nearest_port_size}</Typography>}

                                <Divider />

                                <Typography variant="subtitle1" fontWeight="bold">Informations sur l'estuaire à proximité</Typography>
                                {sample.nearest_estuary_name && sample.nearest_estuary_distance !== undefined && (
                                    <Typography>Nom de l'estuaire: {sample.nearest_estuary_name} ({sample.nearest_estuary_distance} km)</Typography>
                                )}
                                {sample.nearest_river_name && <Typography>Nom de la rivière à proximité: {sample.nearest_river_name}</Typography>}

                                <Divider /> */}

                                <Typography variant="subtitle1" fontWeight="bold">Nettoyage du site</Typography>
                                {sample.recent_cleaning && <Typography>Récent nettoyage: {sample.recent_cleaning}</Typography>}
                                {sample.cleaning_frequency && <Typography>Fréquence de nettoyage: {sample.cleaning_frequency}</Typography>}
                                {sample.cleaning_method && <Typography>Méthode de nettoyage: {sample.cleaning_method}</Typography>}
                                {sample.cleaning_responsibility && <Typography>Responsable du nettoyage: {sample.cleaning_responsibility}</Typography>}
                                {sample.tide_gauge_presence !== undefined && <Typography>Présence d'un maréagraphe: {sample.tide_gauge_presence}</Typography>}

                                <Divider />

                                <Typography variant="subtitle1" fontWeight="bold">Évènements météorologiques</Typography>
                                {sample.recent_meteo_events && <Typography>Événements récents: {sample.recent_meteo_events}</Typography>}
                                {sample.meteo_interpretation && <Typography>Interprétation de la météo: {sample.meteo_interpretation}</Typography>}
                            </Box>

                        )}
                        {tabIndex === 3 && (
                            <Box>
                                <Typography variant="h6" fontWeight="bold">Détails sur les déchets macro</Typography>
                                {sample.macro_weight && <Typography>Poids des macro déchets: {sample.macro_weight} kg</Typography>}
                                {sample.macro_volume && <Typography>Volume des macro déchets: {sample.macro_volume} m³</Typography>}
                                {sample.total_macro_items && <Typography>Nombre total de macro déchets: {sample.total_macro_items}</Typography>}
                            </Box>
                        )}
                        {tabIndex === 4 && (
                            <Box>
                                <Typography variant="h6" fontWeight="bold">Exporter les données</Typography>

                                {!excelLink && (
                                    <Box sx={{ mt: 2 }}>
                                        <Button
                                            variant="contained"
                                            onClick={handleGenerateExcel}
                                            disabled={isGenerating}
                                        >
                                            {isGenerating ? "Génération en cours..." : "Télécharger le fichier Excel"}
                                        </Button>
                                    </Box>
                                )}

                                {excelLink && (
                                    <Box sx={{ mt: 2 }}>
                                        <a href={excelLink} target="_blank" rel="noopener noreferrer">
                                            <Typography color="primary">Ouvrir le fichier Excel</Typography>
                                        </a>
                                    </Box>
                                )}
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
        </Drawer>
    );
};

export default DataDetailsDrawer;
